import { useMemo, useContext } from "react";
import { TradeDataContext } from "../containers/TradeData";

/**
 * Manages the trade in state for the user and manages how that state is stored
 */
function useTradeInState() {
  const [state, dispatch] = useContext(TradeDataContext);
  const update = useMemo(
    function () {
      return (property, value) => {
        if (!value) {
          dispatch({ type: "update", prop: property });
        } else {
          dispatch({ type: "update", prop: { [property]: value } });
        }
      };
    },
    [dispatch]
  );

  return [state, update];
}

export default useTradeInState;
